import PropTypes from 'prop-types';

export default function Search({ searchValue, setSearchValue, getLabel }) {
	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
		}
	};

	return (
		<div className="feature__controls--search">
			<div className="feature__controls--search-input">
				<form role="search" className="search-form" autoComplete="off">
					<input
						type="search"
						className="search-field"
						placeholder={getLabel('search_placeholder')}
						value={searchValue}
						name="s"
						onChange={(event) => setSearchValue(event.target.value)}
						onKeyDown={handleKeyDown}
					/>
					<div className={`search-form__clear ${searchValue ? 'show' : ''}`} onClick={() => setSearchValue('')}>
						<span></span>
						<span></span>
					</div>
				</form>
			</div>
		</div>
	);
}

Search.propTypes = {
	searchValue: PropTypes.string,
	setSearchValue: PropTypes.func,
	getLabel: PropTypes.func,
};
